<template>
  <v-form ref="form" class="pa-4" v-model="internalValid">
    <!-- Basic Information   start   -->
    <v-expansion-panels multiple v-model="expanded">
      <v-expansion-panel>
        <v-expansion-panel-header class="exp-header">Basic Information</v-expansion-panel-header>
        <v-expansion-panel-content>
   
    <v-text-field
    class="pt-5"
      dense
      outlined
      v-model="draft.name"
      :rules="[formRules.required]"
      label="Company Name"
      placeholder="Type Company Name"
    ></v-text-field>
    <div class="d-flex align-center pb-5 " v-if="draft.id" >
      <v-select
        v-model="ownerSelection"
        :items="companyUsers"
        :item-text="userText"
        return-object
        hide-details
        attach
        dense
        outlined
        clearable
        label="Company Owner"
        placeholder="Select a user"
      />
      <v-btn color="primary" :loading="ownerUpdating" :disabled="!ownerSelection || ownerUpdating" @click="applyOwnerSelection">
        Update owner
      </v-btn>
    </div>
    <div class="d-flex align-center pb-5 " v-if="!draft.id" >
      <v-text-field
    class="pt-5"
      dense
      outlined
      v-model="draft.owner.email"
      :rules="[formRules.required, formRules.email]"
      label="Owner Email"
      placeholder="Type Owner Email"
    ></v-text-field>
    </div>
    <DatePicker
      v-model="draft.licenseExpiryDate"
      :rules="[formRules.required]"
      label="License Expiry Date"
    />

 <v-row no-gutters class="mt-8">
  <v-col cols="12" >
    <v-select
      :rules="[formRules.required]"
      dense
      label="Region"
      outlined
      item-text="name"
      item-value="id"
      attach
      v-model="draft.region"
      :items="regions"
    >
      <template v-slot:selection="{ item }">
        <img :src="item.flag" class="mr-1" /> <span>{{ item.name }}</span>
      </template>
      <template v-slot:item="{ item }">
        <img :src="item.flag" class="mr-1" /> <span>{{ item.name }}</span>
      </template>
    </v-select>

  </v-col>
 </v-row>

 <v-row no-gutters class="mt-4">
  <v-col cols="12" >
    <v-select
      dense
      label="APS Region (Autodesk Storage)"
      outlined
      item-text="name"
      item-value="id"
      attach
      v-model="draft.apsRegion"
      :items="apsRegions"
      hint="Region for Autodesk Platform Services (model storage & derivatives)"
      persistent-hint
    >
    </v-select>
  </v-col>
 </v-row>

    <!-- Basic Information  end -->
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- limits and access start -->
<v-expansion-panel>
  <v-expansion-panel-header class="exp-header">Limits & Access</v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-row no-gutters   class="">
      <v-col cols="12" class="pt-2  " no-gutters>
        <div class="text-subtitle-1">
            Facilities Limit :
          </div> 
       <v-row no-gutters >
        <v-col cols="6"  class="d-flex align-center">
          <v-checkbox
            v-model="unlimitedFacilities"
            label="Unlimited"
            dense
            hide-details
            class="mb-2 mr-2"
          />
     
            <v-text-field
            v-if="!unlimitedFacilities"
            v-model="draft.facilitiesLimitCount"
            :rules="[formRules.required]"
            dense
            outlined
            hide-details
            type="number"
          
            placeholder="Facilities Limit Count"
          />
       
        </v-col>
        <v-col cols="6" class="d-flex align-center justify-end progress-wrapper" >
          <CountProgress
              :count="draft.facilitiesLimitUsed || 0"
              :limit="draft.facilitiesLimitCount"
              :unlimited="+draft.facilitiesLimitCount === -1"
              icon="mdi-office-building"
              :minWidth="220"
              style="width: 100px;"
            />
        </v-col>
        </v-row>  
         
          
      </v-col>
      <div class="py-2 w-100">
        <v-divider  ></v-divider>
      </div>

      <!-- Users Limit -->
      <v-col cols="12" class="" no-gutters>
        <div class="text-subtitle-1">
            Users Limit :
          </div> 
       <v-row no-gutters >
        <v-col cols="6"  class="d-flex align-center">
          <v-checkbox
            v-model="unlimitedUsers"
            label="Unlimited"
            dense
            hide-details
            class="mb-2 mr-2"
          />
    
          <v-text-field
            v-if="!unlimitedUsers"
            v-model="draft.usersLimitCount"
            :rules="[formRules.required]"
            dense
            outlined
            hide-details
            type="number"
            placeholder="Users Limit Count"
          />
       
        </v-col>
        <v-col cols="6" class="d-flex align-center justify-end progress-wrapper" >
          <CountProgress
              :count="(selected && selected.usersCount) || 0"
              :limit="draft.usersLimitCount"
              :unlimited="+draft.usersLimitCount === -1"
              icon="mdi-account-multiple-outline"
              :minWidth="220"
              style="width: 100px;"
            />
        </v-col>
        </v-row>  
         
          
      </v-col>
      <div class="py-2 w-100">
        <v-divider  ></v-divider>
      </div>
    </v-row>
    <div class="py-2 w-100">
        <v-divider  ></v-divider>
      </div>
    <div class="d-flex  align-center justify-space-between">
      <span class="text-subtitle-1">Desktop Converter Access</span>
      <v-switch class="mt-0" hide-details v-model="draft.desktopConverterAccess"></v-switch>
    </div>

  </v-expansion-panel-content>
         <!-- limits and access end -->
</v-expansion-panel> 
      <v-expansion-panel>
        <v-expansion-panel-header class="exp-header">Custom Theme</v-expansion-panel-header>
        <v-expansion-panel-content>
<!-- Custom Theme   start   -->

    <v-sheet outlined class="mb-4 rounded-lg">
      <v-sheet class="pa-4">
        <v-label class="black--text mb-2 d-block">Background Image</v-label>
        <SingleImageUploader
          id="background-uploader"
          apiUrl="api/Management/Companies/CustomUIImage"
          v-model="draft.customUI.loginBackgroundImageUrl"
        />
      </v-sheet>
    </v-sheet>

    <v-sheet outlined class="mb-4 rounded-lg">
      <v-sheet class="pa-4">
        <v-label class="black--text mb-2 d-block">Company Logo</v-label>
        <SingleImageUploader
          id="company-logo-uploader"
          apiUrl="api/Management/Companies/CustomUIImage"
          v-model="draft.logoUrl"
        />
      </v-sheet>
    </v-sheet>

    <v-sheet outlined class="mb-4 rounded-lg">
      <v-sheet class="pa-4">
        <v-label class="black--text mb-3 d-block">Technology By Logo</v-label>
        <div class="logo-selection-wrapper">
          <div
            class="logo-option"
            :class="{ 'logo-option-selected': draft.customUI.techByLogoType === LogoVariant.WHITE }"
            @click.stop="selectLogoType(LogoVariant.WHITE)"
            role="radio"
            :aria-checked="draft.customUI.techByLogoType === LogoVariant.WHITE"
          >
            <div class="logo-preview white-logo">
              <v-img
                src="/img/White - Technology By Logo.png"
                max-width="100"
                max-height="50"
                contain
                class="logo-image"
              />
            </div>
            <div class="logo-label">White</div>
            <v-icon
              color="success"
              class="logo-check-icon"
              v-if="draft.customUI.techByLogoType === LogoVariant.WHITE"
            >
              mdi-check-circle
            </v-icon>
          </div>

          <div
            class="logo-option"
            :class="{ 'logo-option-selected': draft.customUI.techByLogoType === LogoVariant.BLACK }"
            @click.stop="selectLogoType(LogoVariant.BLACK)"
            role="radio"
            :aria-checked="draft.customUI.techByLogoType === LogoVariant.BLACK"
          >
            <div class="logo-preview black-logo">
              <v-img
                src="/img/Black - Technology By Logo.png"
                max-width="100"
                max-height="50"
                contain
                class="logo-image"
              />
            </div>
            <div class="logo-label">Black</div>
            <v-icon
              color="success"
              class="logo-check-icon"
              v-if="draft.customUI.techByLogoType === LogoVariant.BLACK"
            >
              mdi-check-circle
            </v-icon>
          </div>
        </div>
      </v-sheet>
    </v-sheet>
    <!--  Custom Theme  end -->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>

<script>
import formRules from '@Share/config/form-rules';
import DatePicker from '@Share/components/VDatePicker';
import SingleImageUploader from '@Share/components/SingleImageUploader.vue';
import { LogoVariant } from '@Share/config/enums';
import companyService from '@/features/Company/service/company-management.service';
import CountProgress from '@Company/components/CountProgress.vue';
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';
export default {
  name: 'CompanyBasicInformation',
  props: {
    value: { type: Boolean, default: false },
    selected: { type: Object, required: true },
  },
  data() {
    return {
      internalValid: this.value,
      formRules,
      LogoVariant,
      draft: this.createDraft(this.selected),
      expanded: [0, 1],
      ownerSelection: null,
      ownerUpdating: false,
      usersLoading: false,
      companyUsers: [],
      unlimitedFacilities: false,
      unlimitedModels: false,
      unlimitedUsers: false,
      facilitiesPrevLimit: null,
      modelsPrevLimit: null,
      usersPrevLimit: null,
    };
  },
  computed: {
    regions() {
      return this.$store.getters['COMPANY/GET_REGIONS'];
    },
    apsRegions() {
      return [
        { id: 1, name: 'US' },
        { id: 2, name: 'EMEA' }
      ];
    },
  },
  watch: {
    internalValid(val) {
      this.$emit('input', val);
    },
    value(val) {
      if (val !== this.internalValid) this.internalValid = val;
    },
    unlimitedFacilities(val) {
      if (val) {
        // store previous value before setting to -1 (unlimited)
        this.facilitiesPrevLimit = (this.draft.facilitiesLimitCount !== -1 ? this.draft.facilitiesLimitCount : this.facilitiesPrevLimit) ?? 0;
        this.$set(this.draft, 'facilitiesLimitCount', -1);
      } else {
        // if currently unlimited (-1), restore previous or default to 0
        const restore = (this.facilitiesPrevLimit != null && this.facilitiesPrevLimit !== -1) ? this.facilitiesPrevLimit : 0;
        this.$set(this.draft, 'facilitiesLimitCount', restore);
      }
    },
    unlimitedModels(val) {
      if (val) {
        this.modelsPrevLimit = (this.draft.smallModelsLimitCount !== -1 ? this.draft.smallModelsLimitCount : this.modelsPrevLimit) ?? 0;
        this.$set(this.draft, 'smallModelsLimitCount', -1);
      } else {
        const restore = (this.modelsPrevLimit != null && this.modelsPrevLimit !== -1) ? this.modelsPrevLimit : 0;
        this.$set(this.draft, 'smallModelsLimitCount', restore);
      }
    },
    unlimitedUsers(val) {
      if (val) {
        this.usersPrevLimit = (this.draft.usersLimitCount !== -1 ? this.draft.usersLimitCount : this.usersPrevLimit) ?? 0;
        this.$set(this.draft, 'usersLimitCount', -1);
      } else {
        const restore = (this.usersPrevLimit != null && this.usersPrevLimit !== -1) ? this.usersPrevLimit : 0;
        this.$set(this.draft, 'usersLimitCount', restore);
      }
    },
    'draft.facilitiesLimitCount'(v) {
      this.unlimitedFacilities = +v === -1;
    },
    'draft.usersLimitCount'(v) {
      this.unlimitedUsers = +v === -1;
    },
    'draft.smallModelsLimitCount'(v) {
      this.unlimitedModels = +v === -1;
    },
    // Removed unused scan limit watchers
    selected: {
      handler(newVal) {
        // Rebuild draft when parent selected changes
        this.draft = this.createDraft(newVal);
        this.$nextTick(() => {
          this.syncOwnerSelection();
          // initialize unlimited flags from draft values
          this.unlimitedFacilities = +this.draft.facilitiesLimitCount === -1;
          this.unlimitedUsers = +this.draft.usersLimitCount === -1;
          this.unlimitedModels = +this.draft.smallModelsLimitCount === -1;
        });
        // Load users for the selected company
        this.loadCompanyUsers();
      },
      deep: true,
    },
    draft: {
      handler() {
        // Notify parent about draft changes
        this.$emit('changed', this.getDraft());
      },
      deep: true,
    },
  },
  mounted() {
    this.syncOwnerSelection();
    // initialize unlimited flags from current draft
    this.unlimitedFacilities = +this.draft.facilitiesLimitCount === -1;
    this.unlimitedUsers = +this.draft.usersLimitCount === -1;
    this.unlimitedModels = +this.draft.smallModelsLimitCount === -1;
    // fetch company users initially
    this.loadCompanyUsers();
  },
  methods: {
    createDraft(src) {
      const base = typeof structuredClone === 'function' ? structuredClone(src || {}) : JSON.parse(JSON.stringify(src || {}));
      base.owner = base.owner || {};
      base.customUI = base.customUI || {};
      if (typeof base.customUI.techByLogoType !== 'number') {
        base.customUI.techByLogoType = this.LogoVariant && this.LogoVariant.WHITE !== undefined ? this.LogoVariant.WHITE : 0;
      }
      // Normalize legacy nulls to -1 (unlimited)
      if (base.facilitiesLimitCount === null) base.facilitiesLimitCount = -1;
      if (base.usersLimitCount === null) base.usersLimitCount = -1;
      if (base.smallModelsLimitCount === null) base.smallModelsLimitCount = -1;
      // Ensure default limits exist for progress bars (preserve -1 as unlimited)
      if (typeof base.facilitiesLimitCount === 'undefined') base.facilitiesLimitCount = 0;
      if (typeof base.usersLimitCount === 'undefined') base.usersLimitCount = 0;
      if (typeof base.smallModelsLimitCount === 'undefined') base.smallModelsLimitCount = 0;
      return base;
    },
    getDraft() {
      return typeof structuredClone === 'function' ? structuredClone(this.draft) : JSON.parse(JSON.stringify(this.draft));
    },
    commitToParent() {
      // Emit event with a safe deep copy so parent can apply to its selected
      this.$emit('commit', this.getDraft());
    },
    resetValidation() {
      if (this.$refs.form && this.$refs.form.resetValidation) {
        this.$refs.form.resetValidation();
      }
    },
    selectLogoType(type) {
      // Ensure nested structure exists on draft
      if (!this.draft.customUI) this.$set(this.draft, 'customUI', {});
      this.draft.customUI.techByLogoType = type;
    },
    userText(user) {
      if (!user) return '';
      const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
      return name ? `${name} — ${user.email}` : (user.email || '');
    },
    applyOwnerSelection() {
      if (!this.ownerSelection || !this.selected?.id) return;
      const u = this.ownerSelection;
      this.ownerUpdating = true;
      companyService.updateOwner(this.selected.id, u.id)
        .then(() => {
          // reflect change locally
          this.$set(this.draft, 'owner', {
            ...(this.draft.owner || {}),
            id: u.id,
            email: u.email,
            firstName: u.firstName,
            lastName: u.lastName,
          });
          if (this.$dialog?.notify?.success) {
            this.$dialog.notify.success('Owner updated successfully.', { position: 'top-right', timeout: 2000 });
          }
        })
        .catch((error) => {
          // fallback notify
          debugError('Failed to update owner', error);
          if (this.$dialog?.notify?.error) {
            this.$dialog.notify.error('Failed to update owner');
          }
        })
        .finally(() => {
          this.ownerUpdating = false;
        });
    },
    syncOwnerSelection() {
      if (!this.companyUsers || !this.companyUsers.length) {
        this.ownerSelection = null;
        return;
      }
      const byId = this.draft?.owner?.id;
      const byEmail = this.draft?.owner?.email;
      let match = null;
      if (byId != null) match = this.companyUsers.find(u => u.id === byId);
      if (!match && byEmail) match = this.companyUsers.find(u => u.email === byEmail);
      this.ownerSelection = match || null;
    },
    loadCompanyUsers() {
      const id = this.selected?.id;
      if (!id) {
        this.companyUsers = [];
        this.ownerSelection = null;
        return;
      }
      this.usersLoading = true;
      companyService.getUsers(id)
        .then((res) => {
          const data = res && res.data;
          const list = Array.isArray(data?.items) ? data.items : (Array.isArray(data) ? data : []);
          this.companyUsers = list;
          this.$nextTick(this.syncOwnerSelection);
        })
        .catch((error) => {
          debugError('Failed to load company users', error);
          this.companyUsers = [];
          if (this.$dialog?.notify?.error) {
            this.$dialog.notify.error('Failed to load company users');
          }
        })
        .finally(() => {
          this.usersLoading = false;
        });
    },
    // Removed unused scan-related methods
  },
  components: {
    DatePicker,
    SingleImageUploader,
    CountProgress,
  },
};
</script>

<style scoped>
.exp-header {
  background-color: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 8px 12px;
  font-weight: 600;
}

/* Reduce gap between header and content */
:deep(.v-expansion-panel-content__wrap) {
  padding-top: 8px;
}

/* Dark theme adjustments for header */
:deep(.v-application.theme--dark) .exp-header {
  background-color: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}

.logo-option:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.logo-option-selected {
  border: 2px solid var(--v-success-base);
  background-color: rgba(76, 175, 80, 0.05);
}

.logo-preview {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.white-logo {
  background-color: #c3c3c3;
  border: 1px solid #e0e0e0;
}

.black-logo {
  background-color: white;
  border: 1px solid #e0e0e0;
}

.logo-label {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 4px;
}

.logo-check-icon {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 24px;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
}

/* Dark theme support */
:deep(.v-application.theme--dark) .logo-label {
  color: rgba(255, 255, 255, 0.8);
}

:deep(.v-application.theme--dark) .black-logo {
  background-color: #333;
  border-color: #444;
}

:deep(.v-application.theme--dark) .white-logo {
  background-color: #424242;
  border-color: #555;
}

:deep(.v-application.theme--dark) .logo-option {
  border-color: rgba(255, 255, 255, 0.1);
}

:deep(.v-application.theme--dark) .logo-option-selected {
  background-color: rgba(76, 175, 80, 0.1);
}

@media (max-width: 600px) {
  .logo-selection-wrapper {
    justify-content: center;
  }
  .logo-option {
    width: 160px;
    padding: 12px;
  }
}
</style>
